<ion-card class="reminder-card">
  <ion-card-content>
    <div class="header-row">
      <div>
        <div class="title">{{ 'CLAIM_DOCUMENT_REMINDERS.TITLE' | translate }}</div>
        <ion-note>{{ 'CLAIM_DOCUMENT_REMINDERS.BASE_DATE' | translate:{ baseDate: displayBaseDate } }}</ion-note>
      </div>

      @if (!readonly && !isCreating && !editingReminderId) {
        <ion-button
          fill="clear"
          size="small"
          (click)="startCreate()">
          <app-dynamic-icon slot="start" name="add-outline"></app-dynamic-icon>
          {{ 'COMMON.ADD' | translate }}
        </ion-button>
      }
    </div>

    @if (!visibleReminders.length && !isCreating) {
      <div class="empty-state">
        <div class="empty-title">{{ 'CLAIM_DOCUMENT_REMINDERS.EMPTY_TITLE' | translate }}</div>
        <ion-note>{{ 'CLAIM_DOCUMENT_REMINDERS.EMPTY_HELP' | translate }}</ion-note>
      </div>
    }

    @if (visibleReminders.length) {
      <div class="reminder-list">
        @for (reminder of visibleReminders; track trackByReminderId($index, reminder)) {
          <div class="reminder-row">
            @if (!isEditing(reminder)) {
              <div class="row-content">
                <div class="row-main">
                  <div class="row-topline">
                    <ion-chip [color]="getReminderTone(reminder)">
                      <app-dynamic-icon name="calendar-outline"></app-dynamic-icon>
                      <span>{{ formatReminderDate(getReminderDate(reminder)) }}</span>
                    </ion-chip>
                  </div>

                  <div class="row-note">{{ getReminderNote(reminder) }}</div>
                </div>

                @if (!readonly) {
                  <div class="row-actions">
                    <ion-button fill="clear" size="small" (click)="startEdit(reminder)">
                      <app-dynamic-icon slot="icon-only" name="create-outline"></app-dynamic-icon>
                    </ion-button>
                    <ion-button fill="clear" size="small" color="danger" (click)="deleteReminder(reminder)">
                      <app-dynamic-icon slot="icon-only" name="trash-outline"></app-dynamic-icon>
                    </ion-button>
                  </div>
                }
              </div>
            } @else {
              <div class="editor-shell">
                <div class="editor-grid">
                  <div class="editor-section editor-section--note">
                    <label class="field-label">{{ 'CLAIM_DOCUMENT_REMINDERS.NOTE' | translate }}</label>
                    <ion-textarea
                      autoGrow="true"
                      fill="outline"
                      [placeholder]="'CLAIM_DOCUMENT_REMINDERS.NOTE_PLACEHOLDER' | translate"
                      [(ngModel)]="draft.note">
                    </ion-textarea>
                  </div>

                  <div class="editor-section editor-section--date">
                    <label class="field-label">{{ 'CLAIM_DOCUMENT_REMINDERS.WHEN' | translate }}</label>
                    <ion-segment [(ngModel)]="draft.dateMode">
                      <ion-segment-button value="absolute">
                        <app-dynamic-icon name="calendar-outline"></app-dynamic-icon>
                        <span>{{ 'CLAIM_DOCUMENT_REMINDERS.ABSOLUTE' | translate }}</span>
                      </ion-segment-button>
                      <ion-segment-button value="relative">
                        <app-dynamic-icon name="time-outline"></app-dynamic-icon>
                        <span>{{ 'CLAIM_DOCUMENT_REMINDERS.RELATIVE' | translate }}</span>
                      </ion-segment-button>
                    </ion-segment>

                    @if (draft.dateMode === 'absolute') {
                      <div class="date-fields">
                        <input
                          class="compact-input"
                          type="date"
                          title="{{ 'CLAIM_DOCUMENT_REMINDERS.DATE_INPUT' | translate }}"
                          aria-label="{{ 'CLAIM_DOCUMENT_REMINDERS.DATE_INPUT' | translate }}"
                          [(ngModel)]="draft.absoluteDate">
                      </div>
                    } @else {
                      <div class="date-fields date-fields--relative">
                        <ion-segment [(ngModel)]="draft.offsetDirection">
                          <ion-segment-button value="before">
                            <span>{{ 'CLAIM_DOCUMENT_REMINDERS.BEFORE' | translate }}</span>
                          </ion-segment-button>
                          <ion-segment-button value="after">
                            <span>{{ 'CLAIM_DOCUMENT_REMINDERS.AFTER' | translate }}</span>
                          </ion-segment-button>
                        </ion-segment>
                        <div class="relative-input-row">
                          <input
                            class="compact-input compact-input--small"
                            type="number"
                            min="0"
                            step="1"
                            title="{{ 'CLAIM_DOCUMENT_REMINDERS.OFFSET_INPUT' | translate }}"
                            aria-label="{{ 'CLAIM_DOCUMENT_REMINDERS.OFFSET_INPUT' | translate }}"
                            [(ngModel)]="draft.offsetDays">
                          <div class="help-text">{{ 'CLAIM_DOCUMENT_REMINDERS.RELATIVE_HELP' | translate:{ direction: ('CLAIM_DOCUMENT_REMINDERS.' + (draft.offsetDirection | uppercase)) | translate, baseDate: displayBaseDate } }}</div>
                        </div>
                      </div>
                    }
                  </div>
                </div>

                @if (validationMessageKey) {
                  <div class="validation">{{ validationMessageKey | translate }}</div>
                }

                <div class="editor-actions">
                  <ion-button fill="clear" size="small" (click)="cancelEditing()">
                    <app-dynamic-icon slot="start" name="close-outline"></app-dynamic-icon>
                    {{ 'COMMON.CANCEL' | translate }}
                  </ion-button>
                  <ion-button size="small" (click)="saveDraft()">
                    <app-dynamic-icon slot="start" name="checkmark-outline"></app-dynamic-icon>
                    {{ 'COMMON.SAVE' | translate }}
                  </ion-button>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }

    @if (isCreating) {
      <div class="editor-shell editor-shell--new">
        <div class="editor-grid">
          <div class="editor-section editor-section--note">
            <label class="field-label">{{ 'CLAIM_DOCUMENT_REMINDERS.NOTE' | translate }}</label>
            <ion-textarea
              autoGrow="true"
              fill="outline"
              [placeholder]="'CLAIM_DOCUMENT_REMINDERS.NOTE_PLACEHOLDER' | translate"
              [(ngModel)]="draft.note">
            </ion-textarea>
          </div>

          <div class="editor-section editor-section--date">
            <label class="field-label">{{ 'CLAIM_DOCUMENT_REMINDERS.WHEN' | translate }}</label>
            <ion-segment [(ngModel)]="draft.dateMode">
              <ion-segment-button value="absolute">
                <app-dynamic-icon name="calendar-outline"></app-dynamic-icon>
                <span>{{ 'CLAIM_DOCUMENT_REMINDERS.ABSOLUTE' | translate }}</span>
              </ion-segment-button>
              <ion-segment-button value="relative">
                <app-dynamic-icon name="time-outline"></app-dynamic-icon>
                <span>{{ 'CLAIM_DOCUMENT_REMINDERS.RELATIVE' | translate }}</span>
              </ion-segment-button>
            </ion-segment>

            @if (draft.dateMode === 'absolute') {
              <div class="date-fields">
                <input
                  class="compact-input"
                  type="date"
                  title="{{ 'CLAIM_DOCUMENT_REMINDERS.DATE_INPUT' | translate }}"
                  aria-label="{{ 'CLAIM_DOCUMENT_REMINDERS.DATE_INPUT' | translate }}"
                  [(ngModel)]="draft.absoluteDate">
              </div>
            } @else {
              <div class="date-fields date-fields--relative">
                <ion-segment [(ngModel)]="draft.offsetDirection">
                  <ion-segment-button value="before">
                    <span>{{ 'CLAIM_DOCUMENT_REMINDERS.BEFORE' | translate }}</span>
                  </ion-segment-button>
                  <ion-segment-button value="after">
                    <span>{{ 'CLAIM_DOCUMENT_REMINDERS.AFTER' | translate }}</span>
                  </ion-segment-button>
                </ion-segment>
                <div class="relative-input-row">
                  <input
                    class="compact-input compact-input--small"
                    type="number"
                    min="0"
                    step="1"
                    title="{{ 'CLAIM_DOCUMENT_REMINDERS.OFFSET_INPUT' | translate }}"
                    aria-label="{{ 'CLAIM_DOCUMENT_REMINDERS.OFFSET_INPUT' | translate }}"
                    [(ngModel)]="draft.offsetDays">
                  <div class="help-text">{{ 'CLAIM_DOCUMENT_REMINDERS.RELATIVE_HELP' | translate:{ direction: ('CLAIM_DOCUMENT_REMINDERS.' + (draft.offsetDirection | uppercase)) | translate, baseDate: displayBaseDate } }}</div>
                </div>
              </div>
            }
          </div>
        </div>

        @if (validationMessageKey) {
          <div class="validation">{{ validationMessageKey | translate }}</div>
        }

        <div class="editor-actions">
          <ion-button fill="clear" size="small" (click)="cancelEditing()">
            <app-dynamic-icon slot="start" name="close-outline"></app-dynamic-icon>
            {{ 'COMMON.CANCEL' | translate }}
          </ion-button>
          <ion-button size="small" (click)="saveDraft()">
            <app-dynamic-icon slot="start" name="checkmark-outline"></app-dynamic-icon>
            {{ 'COMMON.SAVE' | translate }}
          </ion-button>
        </div>
      </div>
    }
  </ion-card-content>
</ion-card>